import { USER_VIEW } from '../constants/user';
import { PI_PRODUCT_SUBTYPES } from '../constants/cart';

export const getLimits = (limits) => {
  const annualLimit = limits?.find(({ limit_type }) => limit_type === 'Annual');
  const monthLimit = limits?.find(({ limit_type }) => limit_type === 'Monthly');

  return { annualLimit, monthLimit };
};

const isRestrictionExceeded = (restriction, balance, requestedQty) => {
  if (!restriction) {
    return false;
  }

  const rest = Math.max(restriction - balance, 0);

  return requestedQty > rest;
};

const isOrderLimitApplicable = (product, userView) =>
  product?.order_limit !== null &&
  product?.order_limit !== undefined &&
  (product.order_limit > 0 || userView === USER_VIEW.gileadFieldRepPortal);

export const isOverLimit = (product, nums, addressesCount, userView = '') => {
  const requestedQty = nums * addressesCount;

  const { annualLimit, monthLimit } = getLimits(product?.limits);

  const isCorporateUser = userView === USER_VIEW.gileadCorporateUserPortal;
  const isPIProductSubtype = PI_PRODUCT_SUBTYPES.includes(product?.subtype);
  const isNotCorporateUserOrIsPIProduct =
    !isCorporateUser || isPIProductSubtype;

  if (!isNotCorporateUserOrIsPIProduct) {
    return false;
  }

  const isOrderLimitOverLimit =
    isOrderLimitApplicable(product, userView) &&
    requestedQty > product.order_limit;

  const isMonthOverLimit = isRestrictionExceeded(
    monthLimit?.restriction,
    monthLimit?.balance,
    requestedQty,
  );

  const isAnnualOverLimit = isRestrictionExceeded(
    annualLimit?.restriction,
    annualLimit?.balance,
    requestedQty,
  );

  return isOrderLimitOverLimit || isMonthOverLimit || isAnnualOverLimit;
};

export const getProductsOverLimit = (
  cartProducts,
  addressesCount,
  productsObj,
  userView = '',
) => {
  const productsOverLimit = [];

  const count = addressesCount === 0 ? 1 : addressesCount;

  cartProducts.forEach(({ product, nums }) => {
    if (nums > productsObj?.[product]?.product_available_qty) {
      return;
    }
    if (isOverLimit(productsObj[product], nums, count, userView)) {
      productsOverLimit.push(product);
    }
  });

  return productsOverLimit;
};
